import { PersonalityTagList } from '@findy-code/yuffie/shared/job-description/personality-tag-list';
import { CombinedSkillTagList } from '@findy-code/yuffie/shared/job-description/skill-tag-list';
import { Heading } from '@findy-code/yuffie/ui/heading';
import { Stack } from '@findy-code/yuffie/ui/stack';

import { Tags } from '../tags';

type Props = {
  jobDescriptionsCharacteristicsWithMatches: {
    id: number;
    name: string;
    isMatched?: boolean;
  }[];
  skills: {
    id: number;
    name: string;
  }[];
  tags: {
    id: number;
    name: string;
  }[];
  isLogin: boolean;
  userSkillIds: number[];
  userSelfRecommendSkillIds: number[];
  userPersonalityIds: number[];
};

export const JobFeatures = ({
  jobDescriptionsCharacteristicsWithMatches,
  skills,
  tags,
  isLogin,
  userSkillIds,
  userSelfRecommendSkillIds,
  userPersonalityIds,
}: Props) => {
  return (
    <Stack spacing="l">
      {jobDescriptionsCharacteristicsWithMatches.length > 0 && (
        <Stack aria-labelledby="characteristic-tags" as="section" spacing="l">
          <Heading as="h3" font="heading-m" id="characteristic-tags">
            こだわり条件
          </Heading>
          <Tags skills={jobDescriptionsCharacteristicsWithMatches} />
        </Stack>
      )}

      {skills.length > 0 && (
        <Stack aria-labelledby="skill-tags" as="section" spacing="l">
          <Heading as="h3" font="heading-m" id="characteristics-tags">
            利用技術
          </Heading>
          {isLogin ? (
            <CombinedSkillTagList
              gitHubRepoDerivedUserSkillIds={userSkillIds}
              skills={skills}
              userSelfRecommendedSkillIds={userSelfRecommendSkillIds}
            />
          ) : (
            <Tags skills={skills} />
          )}
        </Stack>
      )}

      {tags.length > 0 && (
        <Stack aria-labelledby="personality-tags" as="section" spacing="l">
          <Heading as="h3" font="heading-m" id="personality-tags">
            趣向性
          </Heading>
          <PersonalityTagList
            personalities={tags}
            type="all"
            userPersonalityIds={userPersonalityIds}
          />
        </Stack>
      )}
    </Stack>
  );
};
